<template>
  <NuxtLayout name="standard">
    <SSection v-if="privacyPolicyPageData" :has-separator="false">
      <ConnectifTag :name="CONNECTIF_PAGE_TAGS.OTHERS" />
      <ConnectifTag :name="CONNECTIF_CONTENT_TAGS.OTHERS" />

      <SMarkdown v-bind="markdown" />
    </SSection>
    <SSpacer />
  </NuxtLayout>
</template>

<script setup lang="ts">
// Constants
import {
  CONNECTIF_PAGE_TAGS,
  CONNECTIF_CONTENT_TAGS,
} from '~~/modules/integrations/connectif/constants'
import { sendConnectifPage } from '~~/modules/integrations/connectif/composables/useConnectifComposable'

// Types
import { type schemaType as privacyPolicyPageSchemaType } from '~~/modules/api/strapi/privacy-policy-page/schema'

// Composables
import { useHeadInfoComposable } from '~~/modules/head/composables/useHeadInfoComposable'
import { useMenuBreadcrumbStore } from '~~/modules/menu/stores/useMenuBreadcrumbStore'

// Apis
import getPrivacyPolicyPageData from '~~/modules/api/strapi/privacy-policy-page'

// Transformers
import { useToSMarkdown } from '~/composables/transformers/useToSMarkdown'

// Components Props
import type { propsInterface as smarkdownProps } from '~~/modules/design-system/sections/s-markdown.vue'

const { setHeadInfo } = useHeadInfoComposable()

const showErrorPage = (error: ApiResponseError) => {
  throw createError({
    statusCode: 503,
    message: error.message,
    fatal: true,
  })
}

const dataApiDetail = await getPrivacyPolicyPageData()

let privacyPolicyPageData: privacyPolicyPageSchemaType
let markdown: smarkdownProps

if (dataApiDetail.success && dataApiDetail.success.data) {
  privacyPolicyPageData = dataApiDetail.success.data

  if (privacyPolicyPageData) {
    setHeadInfo({
      title: privacyPolicyPageData.attributes.head.title,
      description: privacyPolicyPageData.attributes.head.description,
      images: [
        {
          url: privacyPolicyPageData.attributes.head.image.data.attributes.url,
          alt: privacyPolicyPageData.attributes.head.title,
        },
      ],
      robotsVisible: true,
    })

    markdown = {
      text: useToSMarkdown().fromStrapiPrivacyPolicyPage(privacyPolicyPageData),
      responsive: true,
      clear: true,
    }

    const breadCrumbMenuStore = useMenuBreadcrumbStore()
    breadCrumbMenuStore.setMenuBreadcrumb(t('menu.breadcrumb.privacy-policy'))
  }
} else if (dataApiDetail.error) {
  showErrorPage(dataApiDetail.error as ApiResponseError)
}

sendConnectifPage()
</script>
